import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(1.5)
  },
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'start',
    padding: theme.spacing(1.5, 0),
    borderBottom: `1px solid ${theme.palette.grey.light}`,
    '&:last-child': {
      borderBottom: 'none',
    }
  },
  description: {
    color: theme.palette.grey.main,
  }
}))

export default useStyles
